<template>
  <div
    class="align-center background-color-white d-flex flex-column pb-5 pt-10 px-7"
  >
    <div class="font-size-lg font-weight-semibold text-center">
      Welcome to {{ wait(storeInfo, "name") }}
    </div>
    <div class="mb-5">Log in with your Email and Password</div>
    <v-form
      ref="form"
      v-model="valid"
      class="full-width"
      @submit.prevent="validateAndLogin"
    >
      <EmailInput :email="email" :update="update" autofocus />
      <PasswordInput
        :label="'Password (Min. 6 Characters)'"
        :password="password"
        :update="update"
      />
      <v-btn
        color="success"
        :disabled="!valid"
        type="submit"
        block
        large
        rounded
      >
        <div class="font-size-md font-weight-semibold text-capitalize">
          log in
        </div>
      </v-btn>
    </v-form>

    <OrDivider />

    <div class="d-flex full-width justify-space-between mb-4">
      <button @click="toLogInRoute($options.Views.phone)">
        <span class="font-weight-semibold outline-none primary--text"
          >Log in with Phone Number</span
        >
      </button>
      <button @click="toAuthRoute('signup')">
        <span class="font-weight-semibold outline-none primary--text"
          >Sign Up</span
        >
      </button>
    </div>
    <div class="full-width">
      <button class="mb-2" @click="toAuthRoute('request')">
        Forgot your password?
        <span class="font-weight-semibold outline-none primary--text"
          >Reset it</span
        >.
      </button>
    </div>
    <div
      class="color-suva-grey font-weight-semibold text-center"
      :class="$vuetify.breakpoint.xsOnly ? 'font-size-xxs' : 'font-size-sm'"
    >
      By tapping the Log In or Sign Up buttons you agree to our:
    </div>
    <LegalLinks :closeAuth="closeAuth" />
  </div>
</template>

<script>
import { Views } from "@/types/login.js";
import { mapState } from "vuex";
import { wait } from "@/util.js";
import EmailInput from "@/components/Inputs/Email.vue";
import LegalLinks from "@/components/Auth/LogIn/LegalLinks.vue";
import OrDivider from "@/components/Auth/LogIn/OrDivider.vue";
import PasswordInput from "@/components/Inputs/Password.vue";

export default {
  name: "EmailLogInContent",
  components: {
    EmailInput,
    LegalLinks,
    OrDivider,
    PasswordInput,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      valid: true,
    };
  },
  methods: {
    validateAndLogin() {
      const valid = this.$refs.form.validate();
      if (!valid) {
        return;
      }
      this.logInWithEmailAndPassword();
    },
    wait,
  },
  props: {
    closeAuth: Function,
    email: String,
    logInWithEmailAndPassword: Function,
    password: String,
    toAuthRoute: Function,
    toLogInRoute: Function,
    update: Function,
  },
  Views,
};
</script>
